import { Component } from 'react';
import Clipboard from 'clipboard';

import { Button } from 'components/elements/button';
import type {
  ButtonType,
  ButtonSize,
  ButtonColor,
} from 'components/elements/types';
import type { ColorKey } from 'components/utils/styles/types';

type ClipboardButtonProps = {
  copyText: string;
  target?: HTMLElement | string;
  children: React.ReactNode;
  onCopy?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  color?: ButtonColor | ColorKey;
  size?: ButtonSize;
};

export class ClipboardButton extends Component<ClipboardButtonProps> {
  componentDidMount() {
    const { copyText, target } = this.props;

    if (!target && this.copyButton) {
      this.clipboard = new Clipboard(this.copyButton, {
        text: () => copyText,
      });
    }
  }

  componentWillUnmount() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }

  onClick = (clickEvent: React.MouseEvent<HTMLButtonElement>) => {
    const { onCopy, target } = this.props;

    clickEvent.preventDefault();

    if (target as HTMLElement) {
      const listener = (copyEvent: ClipboardEvent) => {
        copyEvent.clipboardData?.setData(
          'text/plain',
          (target as HTMLElement).innerText
        );
        copyEvent.clipboardData?.setData(
          'text/html',
          (target as HTMLElement).innerHTML
        );
        copyEvent.preventDefault();
      };

      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);
    }
    if (onCopy) {
      onCopy(clickEvent);
    }
  };

  private clipboard: Clipboard | null = null;

  private copyButton: HTMLButtonElement | null = null;

  render() {
    const { children, ...rest } = this.props;

    return (
      <Button
        onClick={this.onClick}
        ref={(button) => {
          this.copyButton = button;
        }}
        {...rest}
      >
        {children}
      </Button>
    );
  }
}
